import {EntityMananger} from './core.entity.mananger';

export function EntityTable(tableName: string, uuid?: string, external?: boolean): ClassDecorator {
    return function decorator(target: any) {
        target.prototype.__tableName = tableName;
        target.prototype.__uuid = uuid;
        target.prototype.__external = external;

        EntityMananger.registerEntity(tableName, target.name);
        return target;
    };
}
